import { useWoody } from '../../woody/woody.js';
import { useQuery } from '@tanstack/react-query';
import { chatbotQueryKeys } from './chatbotQueryKeys.js';
import { useAuthStatus } from '@fabric-app/compat';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryChatbotModels = (queryOptions) => {
  const { client } = useWoody();
  const authStatus = useAuthStatus();
  return useQuery({
    queryKey: chatbotQueryKeys.chatbotModels(),
    queryFn: async () => {
      return client.v2("/v2/chatbot/models");
    },
    ...queryOptions,
    enabled: isQueryEnabled([
      authStatus === "authenticated",
      queryOptions?.enabled
    ])
  });
};

export { useQueryChatbotModels };
//# sourceMappingURL=useQueryChatbotModels.js.map
